import * as React from 'react';
import defaultApi from '@Utils/core/api/defaultApi';
import { useAppSelector } from '@Utils/core/redux/useAppSelector';
import { isUserLoggedInSelector } from '@Utils/facade/edgeTs';
import { RAID } from '@Utils/shared/constants/games';
import { getQueryParamByName } from '@Utils/shared/utils/getQueryParamByName';

function getServerFromUrl() {
  return getQueryParamByName('server');
}

async function getUserGameId() {
  const server = getServerFromUrl();
  const apiUrl = server ? `raid/game/userid/?server=${server}` : 'raid/game/userid/';

  return defaultApi<string>(apiUrl);
}

export function useGetUserId(game = RAID) {
  const [userId, setUserId] = React.useState('');
  const isUserLoggedIn = useAppSelector(isUserLoggedInSelector);

  /**
   * Set the initial userId from the query parameters or
   * which will come from the getUserGameId()
   */
  React.useEffect(() => {
    (async () => {
      const userIdFromQuery = getQueryParamByName('userId');

      if (userIdFromQuery) {
        setUserId(userIdFromQuery);
        return;
      }

      if (isUserLoggedIn && game === RAID) {
        const userId = await getUserGameId();

        if (userId && typeof userId === 'string') {
          setUserId(userId);
        }
      }
    })();
  }, [isUserLoggedIn, game]);

  return {
    userId,
    setUserId,
  };
}
